import { withFormsy } from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types';

import { Input as TWInput } from 'twyne-new.ui';

class Input extends React.Component {
  render() {
    const { setValue, getValue, getErrorMessage, isValid, isRequired, isPristine, type, disabled, placeholder, className, min, max, id, autocomplete, rows, maxLength, component: Component = TWInput } = this.props;
    const isInvalidClass = !isValid() && !isPristine() ? 'is-invalid' : '';
    const classesNames = isInvalidClass + " " + className

    const handleChange = (event) => {
      setValue(event.currentTarget.value);

      const cb = this.props.onChange;
      if (cb) {
        cb(event);
      }
    };

    return (
      <div className='relative w-full'>
        <Component
          autoComplete={autocomplete}
          id={id}
          type={type}
          rows={rows}
          className={classesNames}
          onChange={handleChange}
          value={getValue()}
          disabled={disabled}
          placeholder={placeholder || ''}
          maxLength={maxLength}
          {...{ min, max }}
        />
        <span className="invalid-feedback absolute -bottom-4 left-0">
          {getErrorMessage()}
          {isRequired() && !getValue() && ' Field required'}
        </span>
      </div>
    );
  }
}

Input.propTypes = {
  setValue: PropTypes.func,
  getValue: PropTypes.func,
  getErrorMessage: PropTypes.func,
  isValid: PropTypes.func,
  isPristine: PropTypes.func,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string
}

Input.defaultProps = {
  type: 'text',
  disabled: false
}

export default withFormsy(Input);
